// extracted by mini-css-extract-plugin
export var container = "_gu-0";
export var content = "_gu-3";
export var customerTitle = "_gu-4";
export var empty = "_gu-5";
export var gray = "_gu-6";
export var header = "_gu-7";
export var info = "_gu-8";
export var loading = "_gu-2";
export var loadingCard = "_gu-9";
export var oneLine = "_gu-a";
export var personName = "_gu-e";
export var pillContainer = "_gu-b";
export var selected = "_gu-1";
export var text = "_gu-c";
export var twoLines = "_gu-d";
export var unread = "_gu-f";
export var unreadIndicator = "_gu-g";